import React from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import HdIcon from '../../../media/components/icon/HdIcon';
import styles from './HdLink.module.scss';

export interface HdLinkProps {
  dataId?: string;
  to?: string;
  tag?: 'a' | 'button';
  icon?: string;
  iconOnly?: boolean;
  iconSrc?: string;
  iconClasses?: string;
  direction?: 'left' | 'right';
  size?: 'sm' | 'md';
  color?: 'error' | 'light';
  [key: string]: any;
}

export default function HdLink({
  dataId,
  to,
  tag,
  icon,
  iconOnly,
  iconSrc,
  size,
  direction = 'right',
  iconClasses = '',
  color,
  ...props
}: HdLinkProps) {
  const history = useHistory();

  let classes = `text-link`;

  if (icon || iconSrc) {
    classes += ` thumbnail-${direction}`;
  }

  if (props.className) {
    classes += ` ${props.className}`;
  }

  if (icon || iconSrc) {
    classes += ` ${styles.linkIcon}`;
  }

  if (size) {
    classes += ` text-link-${size}`;
  }

  if (color) {
    classes += ` text-link-${color}`;
  }

  if (iconOnly) {
    classes += ' text-link-icon-only';
  }

  const LinkTag = tag || 'a';

  const dataIdGenerator = getDataIdGenerator(dataId);

  const onClickHandler = (e: KeyboardEvent) => {
    if (props.onClick) {
      props.onClick(e);
    }

    if (to) {
      e.preventDefault();
      history?.push(to);
    }
  };

  return (
    <LinkTag
      type={tag === 'button' ? 'button' : undefined}
      {...props}
      className={classes}
      data-id={dataIdGenerator(tag === 'button' ? 'button' : 'link')}
      {...(to ? { href: to } : {})}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onClickHandler(e);
        }
      }}
      onClick={e => onClickHandler(e)}
    >
      {icon && direction === 'left' ? (
        <HdIcon size={props.iconSize || 1} name={icon} className={`thumb ${iconClasses}`} />
      ) : null}

      {iconSrc && direction === 'left' ? <img src={iconSrc} className='thumb' alt='icon' /> : null}

      {props.children}

      {icon && direction !== 'left' ? (
        <HdIcon size={props.iconSize || 1} name={icon} className={`thumb ${iconClasses}`} />
      ) : null}

      {iconSrc && direction !== 'left' ? <img src={iconSrc} className='thumb' alt='icon' /> : null}
    </LinkTag>
  );
}
